import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatDialogCloseEvent } from '../../../const';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TicketManagementService } from '../ticket-management.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-raise-ticket',
  templateUrl: './raise-ticket.component.html'
})
export class RaiseTicketComponent {

  createTicketForm: FormGroup;
  selectedFileName: string = 'Click to upload';
  maxSize: number = 1 * 1024 * 1024; // 1 MB in bytes
  selectedFile: File | null = null;
  
  constructor( public dialog: MatDialog, 
    @Optional() public dialogRef: MatDialogRef<RaiseTicketComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private ticketManagementService: TicketManagementService,
    private toasterService: ToastrService) {

      this.createTicketForm = this.fb.group({
        subject: ['', [Validators.required, Validators.maxLength(300)]],
        description: ['', [Validators.required, Validators.maxLength(300)]]
      });

    }

    onFileSelected(event: any) {
      const file = event.target.files[0];
  
      if (file) {
        if (file.size <= this.maxSize) {
          this.selectedFile = file;
          this.selectedFileName = file.name;
        } else {
          this.toasterService.warning('File size must be less than 1 MB.');
          this.selectedFile = null;
          this.selectedFileName = 'Click to upload';
        }
      } else {
        this.selectedFile = null;
        this.selectedFileName = 'Click to upload';
      }
    }

    submitTicket() {
      if (this.createTicketForm.invalid) {
        this.toasterService.warning('Please fill in the required fields');
        return;
      }
  
      const formData = new FormData();
      formData.append('TicketSubject', this.createTicketForm.get('subject')?.value);
      formData.append('TicketDescription', this.createTicketForm.get('description')?.value);
  
      if (this.selectedFile) {
        formData.append('File', this.selectedFile, this.selectedFile.name);
      }

      this.ticketManagementService.createTicket(formData).subscribe({
        next: (response) => {
          this.toasterService.success('Ticket created successfully!', 'Success');
          this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS});
        },
        error: (error) => {
          console.error('Error creating ticket', error);
          this.toasterService.error(error, 'Error')
          this.closePopup();
        }
      });
    }
 
    closePopup(){
      this.dialogRef.close({event: MatDialogCloseEvent.CANCELLED});
    }
}
